module.exports = __webpack_public_path__ + "media/images/icon-wechat@2x-7f16430c64a7ad3453036179d5d65c9b.png";